import React from "react";
import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { DisplayField } from "../util/DisplayField";
import { formatDateValue } from "../util/tableUtils";

export const AgricultureClaimDescription = (props) => {
  const { claim } = props;
  const { t } = useTranslation();

  return (
    <Box p={1}>
      <Box display="flex">
        <Box flex={1} mr="0.5em">
          <DisplayField label={t("agriculture.bulletinId")} value={claim.bulletinID} />
        </Box>

        <Box flex={1} mr="0.5em">
          <DisplayField label={t("agriculture.complainId")} value={claim.complainID} />
        </Box>

        <Box flex={1} mr="0.5em">
          <DisplayField label={t("agriculture.damageDate")} value={formatDateValue(claim.damageDate)} />
        </Box>
      </Box>

      <Box display="flex"></Box>

      <Box display="flex">
        <Box flex={1} mr="0.5em">
          <DisplayField label={t("agriculture.adversity")} value={claim.adversityDescription} />
        </Box>
        <Box flex={1} mr="0.5em">
          <DisplayField label={t("agriculture.perilName")} value={claim.perilName} />
        </Box>
      </Box>
    </Box>
  );
};
